import { render, staticRenderFns } from "./Faturas.vue?vue&type=template&id=2bc60444&"
import script from "./Faturas.vue?vue&type=script&lang=ts&"
export * from "./Faturas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports